<template>
  <v-layout>
    <v-flex>
      <!-- The pagination component at the top -->
      <v-items-grid-pagination hide-message />
      <!-- All the items of the category -->
      <v-layout justify-center wrap>
        <v-flex v-for="(item, index) in items" :key="index" class="pa-2" xs12 sm4 md3 lg2>
          <v-items-grid-card :item="item" />
        </v-flex>
      </v-layout>
      <!-- A spinner to show if there are no items -->
      <v-layout v-if="loadingCategoryItems" justify-center>
        <v-flex class="my-5" shrink>
          <!-- A spinner to show while getting the items -->
          <v-pulse-loader :loading="loadingCategoryItems" />
        </v-flex>
      </v-layout>
      <!-- The pagination component at the bottom -->
      <v-items-grid-pagination />
    </v-flex>
  </v-layout>
</template>

<script>
import { mapState } from "vuex";
import VItemsGridCard from "./ItemCard";
import VItemsGridPagination from "./ItemsGridPagination";
import VPulseLoader from "vue-spinner/src/PulseLoader";

export default {
  components: {
    VItemsGridCard,
    VItemsGridPagination,
    VPulseLoader
  },
  props: {
    /**
     * The items to show in this grid with all their properties.
     */
    items: {
      type: Array,
      required: true
    }
  },
  computed: {
    ...mapState("classifier", ["loadingCategoryItems"])
  }
};
</script>